// src/pages/Payment/PaymentSuccessPage.tsx
import React, { useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { getCookie } from "common/Cookie";

const PaymentSuccessPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const token = getCookie("accessToken");
    const paymentKey = searchParams.get("paymentKey");
    const orderId    = searchParams.get("orderId");
    const amountRaw  = searchParams.get("amount");

    console.log("[SUCCESS_URL_PARAMS]", { paymentKey, orderId, amountRaw });

    if (!paymentKey || !orderId || !amountRaw) {
      alert("결제 승인에 필요한 정보가 부족합니다.");
      if (window.opener) {
        window.opener.postMessage({ type: "PAYPAL_FAIL", reason: "MISSING_PARAMS" }, window.location.origin);
        window.close(); return;
      }
      navigate("/schedule-contact"); return;
    }

    (async () => {
      try {
        const amount = Number(Number(amountRaw).toFixed(2));
        const res = await fetch("/api/confirm/widget", {
          method: "POST",
          headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
          body: JSON.stringify({ paymentKey, orderId, amount }),
        });
        const json = await res.json();
        if (!res.ok) {
          alert(`승인 실패: ${json.code ?? ""} ${json.message ?? ""}`);
          throw new Error(json.message || "결제 승인 실패");
        }

        // 부모 창에 성공 전달(해외 성공 모달 유도)
        if (window.opener) {
          window.opener.postMessage(
            { type: "PAYPAL_SUCCESS", orderId, amount },
            window.location.origin
          );
          window.close(); return;
        }

        navigate("/manage-contacts");
      } catch (err: any) {
        console.error("[CONFIRM_WIDGET_ERROR]", err);
        if (window.opener) {
          window.opener.postMessage({ type: "PAYPAL_FAIL", reason: err?.message }, window.location.origin);
          window.close(); return;
        }
        navigate("/schedule-contact");
      }
    })();
  }, [searchParams, navigate]);

  return (
    <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", height: "100vh", gap: 20 }}>
      <h2>결제를 안전하게 처리중입니다.</h2>
      <p>잠시만 기다려주세요. 이 페이지를 벗어나지 마세요.</p>
    </div>
  );
};

export default PaymentSuccessPage;
